import React from 'react';
import SectionHeader from 'commonComponents/Headers/SectionHeader/SectionHeader';
import image from 'oldAssets/images/team/team_office.webp';
import styles from './Mission.module.scss';

const Mission = ({ title, subtitle, text }) => {
  const headerProps ={
    title,
    subtitle,
    anchor: 'our-mission'
  };

  return (
    <section className={ styles.Mission }>
      <figure>
        <img src={ image } />
      </figure>
      <article>
        <SectionHeader { ...headerProps } />
        { text && text.map(( paragraph, i ) => <p key={ i }>{ paragraph }</p>) }
      </article>      
    </section>
  );
};

export default Mission;
